import logoDark from '../../assets/media/logo-dark.svg';
import logoLight from '../../assets/media/logo-light.svg';
import logoImgSmall from '../../assets/media/logo-small.svg';
import logoImg from '../../assets/media/logo.svg';
import { ThemeEnum } from '../../utils/enums';

export const logoPathMap: Record<ThemeEnum, string[]> = {
  [ThemeEnum.Basic]: [logoImgSmall, logoImg],
  [ThemeEnum.Dark]: [logoDark],
  [ThemeEnum.Light]: [logoLight],
};
